export const COUNTER_PARTY_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  // Must stay all-lowercase (no internal capital): the shared package
  // @zenbusiness/graphql-commons-banking maps Unit's raw tags.status via a
  // blanket `.toLowerCase()` with no camelCase preservation (see
  // node_modules/@zenbusiness/graphql-commons-banking/utils/bankingCounterparties/mapBankingCounterparty.js:18
  // - `status: attributes.tags.status.toLowerCase()`), so Unit's
  // `NotRelinkable` arrives here as the literal string 'notrelinkable'.
  NOT_RELINKABLE: 'notrelinkable',
  ALL: 'all'
};

export const COUNTER_PARTY_STATUS_LABEL = {
  NO_LONGER_LINKED: 'no longer linked',
  CANNOT_BE_RELINKED: "can't be relinked"
};

export const GET_COUNTER_PARTIES_CONNECT_TYPE = {
  PAYEE: 'payee',
  PLAID: 'plaid'
};
